import { toast } from 'sonner';

import { STATUS } from '@/enums/status';
import { useNotificationsFilters } from '@/hooks/useNotificationsFilters';

import Notification from './Notification';

const TOAST_DURATION = 10000;

type NotificationItem = ReturnType<typeof useNotificationsFilters>['filteredNotifications'][number];

interface NotificationToastItemProps {
  notification: NotificationItem;
  toastId: string | number;
  paused?: boolean;
  onFinished: () => void;
}

const NotificationToastItem: React.FC<NotificationToastItemProps> = ({
  notification,
  toastId,
  paused = false,
  onFinished,
}) => (
  <Notification
    title={notification.title}
    message={notification.message}
    status={STATUS.INFO}
    duration={TOAST_DURATION}
    paused={paused}
    link={notification.link}
    openInNewTab={notification.openInNewTab}
    onClose={() => {
      // Reporting the toast as finished hands the countdown over to the next one, whether the
      // countdown reached 0 or the user closed the toast manually.
      onFinished();
      toast.dismiss(toastId);
    }}
  />
);

export { NotificationToastItem, TOAST_DURATION };
export type { NotificationItem, NotificationToastItemProps };
